export default __webpack_public_path__ + "static/hero-bg-mobile-e73129d3f4ce23ba0eaa378b3e5fd193.png";